import codemirror from 'codemirror';
export default codemirror;

